import { useEffect, useLayoutEffect, useRef } from 'react';

export function useMediaQueryListener(query: string, callback: (matches: boolean) => void) {
  const callbackRef = useRef(callback);
  useLayoutEffect(() => {
    callbackRef.current = callback;
  }, [callback]);
  useEffect(() => {
    const media = window.matchMedia(query);
    const handleMediaChange = (e: MediaQueryListEvent) => {
      callbackRef.current(e.matches);
    };
    media.addEventListener('change', handleMediaChange);
    return () => media.removeEventListener('change', handleMediaChange);
  }, [query]);
}
